<script lang="ts">
  import { onDestroy } from 'svelte';

  export let pairingCode: string;
  export let deviceId: string;
  export let expiresAt: string | null = null;

  let remaining = 0;
  let timerId: ReturnType<typeof setInterval> | null = null;

  $: setupTimer(expiresAt);

  function setupTimer(at: string | null) {
    if (timerId) {
      clearInterval(timerId);
      timerId = null;
    }
    if (!at) return;
    const target = new Date(at).getTime();
    const tick = () => {
      remaining = Math.max(0, Math.floor((target - Date.now()) / 1000));
    };
    tick();
    timerId = setInterval(tick, 1000);
  }

  onDestroy(() => {
    if (timerId) clearInterval(timerId);
  });

  function format(seconds: number): string {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  }
</script>

<div class="pair">
  <div class="brand">Signage Submarino</div>
  <p class="instruction">Para activar esta pantalla, ingresá este código en el panel:</p>

  <div class="code">{pairingCode}</div>

  {#if expiresAt && remaining > 0}
    <div class="ttl">Expira en {format(remaining)}</div>
  {:else if expiresAt && remaining === 0}
    <div class="ttl warn">El código expiró. Esperá unos segundos…</div>
  {/if}

  <div class="meta">
    <span>device-id:</span>
    <code>{deviceId}</code>
  </div>

  <p class="hint">
    Panel: <strong>signage.submarino.delivery</strong> → Pantallas → Agregar nueva
  </p>
</div>

<style>
  .pair {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #0c4a6e 0%, #0ea5e9 100%);
    color: white;
    text-align: center;
    padding: 2rem;
  }
  .brand {
    font-size: 1.5rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    opacity: 0.85;
    margin-bottom: 3rem;
  }
  .instruction {
    font-size: 1.5rem;
    opacity: 0.9;
    margin-bottom: 2rem;
  }
  .code {
    font-size: 8rem;
    font-weight: 800;
    letter-spacing: 0.15em;
    font-family: 'SF Mono', Menlo, Consolas, monospace;
    background: rgba(255, 255, 255, 0.1);
    padding: 1rem 3rem;
    border-radius: 1rem;
    margin-bottom: 1rem;
    backdrop-filter: blur(20px);
    border: 2px solid rgba(255, 255, 255, 0.2);
  }
  .ttl {
    opacity: 0.7;
    margin-bottom: 2rem;
  }
  .ttl.warn { color: #fbbf24; }
  .meta {
    display: flex;
    gap: 0.5rem;
    align-items: baseline;
    opacity: 0.6;
    font-size: 0.9rem;
    margin-bottom: 1rem;
  }
  .meta code {
    background: rgba(0, 0, 0, 0.2);
    padding: 0.2rem 0.5rem;
    border-radius: 0.25rem;
  }
  .hint {
    opacity: 0.6;
    font-size: 1rem;
    margin-top: 2rem;
  }
</style>
